import { render, staticRenderFns } from "./ThematicPageHeaderPreview.vue?vue&type=template&id=f4afee9e&scoped=true&"
import script from "./ThematicPageHeaderPreview.vue?vue&type=script&lang=js&"
export * from "./ThematicPageHeaderPreview.vue?vue&type=script&lang=js&"
import style0 from "./ThematicPageHeaderPreview.vue?vue&type=style&index=0&id=f4afee9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4afee9e",
  null
  
)

export default component.exports